import { ChartsSection } from "./ChartsSection";
import { InputSection } from "./InputSection";
import { ResultsSection } from "./ResultsSection";
import "./VLP.css";

const VLPCalculator = () => {
	const handlePaste = () => { };

	return (
		<div className="vlp__container" onPasteCapture={handlePaste} tabIndex={0}>
			<InputSection />
			<ResultsSection />
			<ChartsSection />
		</div >
	)
}

export default VLPCalculator;
